export interface NavUrlItem {
    url?: string;
    isExternal?: boolean;
}

const isUrlPrefixOf = (url: string, pathname: string): boolean =>
    pathname === url || pathname.startsWith(`${url}/`);

const isInternalMatch = (item: NavUrlItem, pathname: string): item is NavUrlItem & { url: string } =>
    !item.isExternal && typeof item.url === 'string' && isUrlPrefixOf(item.url, pathname);

const longerOf = (longest: string | null, url: string): string =>
    longest === null || url.length > longest.length ? url : longest;

export const longestMatchingUrl = (items: NavUrlItem[], pathname: string): string | null =>
    items
        .filter((item) => isInternalMatch(item, pathname))
        .map((item) => item.url as string)
        .reduce<string | null>((longest, url) => longerOf(longest, url), null);
